import { loggedUser_actionType } from '../actionTypes/loggedUser-actionType';

export function getLoggedUser(userObject) {
    return(dispatch) => {
        dispatch({
            type: loggedUser_actionType.GET_LOGGED_USER_SUCCESS,
            data: userObject
        });
    };
}